const BOOKING_DROPDOWN_CONTENT = [
  'Strategiegespräch',
  'Nachfassmail',
  'Anruf 1',
  'Anruf 2',
  'Abschlussmail',
  'Reaktivierungsanruf',
  'Buchung Paket Test-only',
  'Buchung Paket Basic',
  'Buchung Paket Advanced',
  'Buchung Paket Professional'
];

module.exports = BOOKING_DROPDOWN_CONTENT;
